import React, { useState, useEffect, useReducer } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UiTextArea, UiToggle, UiSelect, PageHeader, UiButton, OverlayLoader, BgLoader, UiTagInput, UiInput } from "../../ui";
import { useStore } from "../../state.js";
import * as yup from "yup";
import { useNavigate, useOutletContext } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { instance } from "../../axios";
import { Select } from 'antd';
import { fi } from "date-fns/locale";


export default function Settings() {
  const [loader, showLoader] = useState(false);
  const [state, setState] = useState([]);
  const [fy] = useOutletContext();
  const schema = yup.object().shape({
    sales_wa_status: yup.bool(),
    sales_wa_msg: yup.string().nullable().when('sales_wa_status', {
      is: true,
      then: (rule) => rule
        .required('Enter message')
    }),

    rcpt_wa_status: yup.bool(),
    rcpt_wa_msg: yup.string().nullable().when('rcpt_wa_status', {
      is: true,
      then: (rule) => rule
        .required('Enter message')
    }),

    os_wa_status: yup.bool(),
    os_wa_msg: yup.string().nullable().when('os_wa_status', {
      is: true,
      then: (rule) => rule
        .required('Enter message')
    }),

    os_weeks: yup.mixed().nullable().when('os_wa_status', {
      is: true,
      then: yup.array().nullable().min(1, 'Select days')
        .of(
          yup.object().nullable().shape({
            label: yup.string().required(),
            value: yup.string().required(),
          })).required("Select days")
    }),


    os_balance_date: yup.string().nullable().when('os_wa_status', {
      is: true,
      then: (rule) => rule
        .required('Select')
    }),

    os_send_on: yup.string().nullable().when('os_wa_status', {
      is: true,
      then: (rule) => rule
        .required('Select')
    }),

    att_wa_status: yup.bool(),
    att_wa_msg: yup.string().nullable().when('att_wa_status', {
      is: true,
      then: (rule) => rule
        .required('Enter message')
    }),

    daybook_status: yup.bool(),
    daybook_mobile: yup.string().nullable().when('daybook_status', {
      is: true,
      then: (rule) => rule
        .required('Enter mobile number')
    }),

    daybook_offset: yup.string().nullable().when('daybook_status', {
      is: true,
      then: (rule) => rule
        .required('Select')
    }),

    entry_copy: yup.bool(),
    entry_copy_to: yup.string().nullable().when('entry_copy', {
      is: true,
      then: (rule) => rule
        .required('Enter mobile number')
    }), 
    send_on: yup.string().nullable().when('daybook_status', {
      is: true,
      then: (rule) => rule
        .required('Select')
    }),


  });
  const {
    register,
    handleSubmit,
    control,
    watch,
    unregister,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    SaveTag(data);
    //reset();
  };
  var SaveTag = (e) => {

    showLoader(true);
    instance({
      method: "post",
      url: "/update_settings",
      data: e,
      headers: { "Content-Type": "application/json" },
    })
      .then(function (response) {
        showLoader(false);
        if (response.data.status == "error") {
          toast(response.data.msg, { type: "error" });
        }
        if (response.data.status == "success") {
          toast(response.data.msg, { type: "success" });

        }
      })
      .catch(function (response) { });
  };
  const fetchData = () => {

    instance
      .get("/settings")
      .then(function (response) {
        setState(response.data)
        reset(response.data.settings)
      })
      .catch(function (error) { })
      .then(function () { });
  }
  useEffect(() => {
    fetchData()

  }, []);


  return (
    <>
      <Helmet>
        <title>
          Settings
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Settings" >



          </PageHeader>

          <OverlayLoader visible={loader} />
          {state.status ?
            <div className="position-relative mb-4">

              <form onSubmit={handleSubmit(onSubmitHandler)}>

                <div className="row">

                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">Sales</div>
                      <div className="card-body">

                        <UiToggle
                          id="sales_wa_status"
                          name="sales_wa_status"
                          value="1"
                          title="Enable Automated Whatsapp Message"
                          {...register("sales_wa_status")}
                        />
                        <UiTextArea

                          label="WhatsApp Content"
                          name="sales_wa_msg"
                          message={errors.sales_wa_msg?.message}
                          {...register("sales_wa_msg")}
                        />
                        <UiToggle
                          id="sales_wa_attach"
                          name="sales_wa_attach"
                          value="1"
                          title="Attach Invoice PDF"
                          {...register("sales_wa_attach")}
                        />
                        <p><b>Variables: </b>##account##, ##contact_person##, ##amount##, ##date##, ##invoice_number##, ##items##, ##closing_balance##</p>
                      </div>
                    </div>

                  </div>



                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">Receipt</div>
                      <div className="card-body">

                        <UiToggle
                          id="rcpt_wa_status"
                          name="rcpt_wa_status"
                          value="1"
                          title="Enable Automated Whatsapp Message"
                          {...register("rcpt_wa_status")}
                        />
                        <UiTextArea

                          label="WhatsApp Content"
                          name="rcpt_wa_msg"
                          message={errors.rcpt_wa_msg?.message}
                          {...register("rcpt_wa_msg")}
                        />
                        <UiToggle
                          id="rcpt_wa_attach"
                          name="rcpt_wa_attach"
                          value="1"
                          title="Attach Receipt PDF"
                          {...register("rcpt_wa_attach")}
                        />
                        <p><b>Variables: </b>##account##, ##contact_person##, ##amount##, ##date##, ##receipt_number##, ##payment_account##, ##closing_balance##</p>
                      </div>
                    </div>

                  </div>

                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">Outstanding</div>
                      <div className="card-body">

                        <UiToggle
                          id="os_wa_status"
                          name="os_wa_status"
                          value="1"
                          title="Enable Automated Whatsapp Message"
                          {...register("os_wa_status")}
                        />
                        <UiTextArea

                          label="WhatsApp Content"
                          name="os_wa_msg"
                          message={errors.os_wa_msg?.message}
                          {...register("os_wa_msg")}
                        />
                        <Controller

                          name="os_weeks"
                          control={control}
                          render={({ field }) => (
                            <UiTagInput
                              label="Send Message on"
                              //defaultValue={['a10', 'c12']}
                              message={errors.os_weeks?.message}
                              {...field}
                              options={[{ 'label': 'Sunday', 'value': 'Sunday' }, { 'label': 'Monday', 'value': 'Monday' }, { 'label': 'Tuesday', 'value': 'Tuesday' }, { 'label': 'Wednesday', 'value': 'Wednesday' }, { 'label': 'Thursday', 'value': 'Thursday' }, { 'label': 'Friday', 'value': 'Friday' }, { 'label': 'Saturday', 'value': 'Saturday' }]}
                            />
                          )}
                        />


                        <UiSelect
                          name='os_balance_date'
                          label="Outstanding Amount Consideration"

                          message={errors.os_balance_date?.message}
                          options={["Current Date", "Last Month"]}
                          {...register(`os_balance_date`)}
                        />
                         <UiSelect
                          label='Send Message on'
                          name="os_send_on"

                          message={errors.os_send_on?.message}
                          options={["00","01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]}
                          {...register(`os_send_on`)}
                        />
                        <p><b>Variables: </b>##account##, ##contact_person##, ##amount##, ##date##</p>
                      </div>
                    </div>

                  </div>


                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">Attendance</div>
                      <div className="card-body">

                        <UiToggle
                          id="att_wa_status"
                          name="att_wa_status"
                          value="1"
                          title="Enable Automated Whatsapp Message"
                          {...register("att_wa_status")}
                        />
                        <UiTextArea

                          label="WhatsApp Content"
                          name="att_wa_msg"
                          message={errors.att_wa_msg?.message}
                          {...register("att_wa_msg")}
                        />

                        <p><b>Variables: </b>##account##, ##attendance##, ##date##</p>
                      </div>
                    </div>

                  </div>

                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">Daybook Report</div>
                      <div className="card-body">

                        <UiToggle
                          id="daybook_status"
                          name="daybook_status"
                          value="1"
                          title="Enable Automated Daybook Whatsapp "
                          {...register("daybook_status")}
                        />
                        <UiInput
                          name={`daybook_mobile`}
                          required={true}
                          label="Mobile Number"
                          {...register(`daybook_mobile`)}
                          message={errors.daybook_mobile?.message}
                        />
                        <UiSelect
                          label='Send Daybook of'
                          name="daybook_offset"

                          message={errors.daybook_offset?.message}
                          options={["Today", "Yesterday"]}
                          {...register(`daybook_offset`)}
                        />
                        <UiSelect
                          label='Send Daybook on'
                          name="send_on"

                          message={errors.send_on?.message}
                          options={["00","01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]}
                          {...register(`send_on`)}
                        />
                      </div>
                    </div>

                  </div>



                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">Due Slip Note</div>
                      <div className="card-body">

                        <UiInput
                          name={`dueslip_note`}
                          label="Due Slip Note"
                          {...register(`dueslip_note`)}
                          message={errors.dueslip_note?.message}
                        />

                        <UiInput
                          name={`upi`}
                          label="UPI ID"
                          {...register(`upi`)}
                          message={errors.upi?.message}
                        />
                      </div>
                    </div>

                  </div>



                  <div className="col-md-6">
                    <div className="card card-default mb-4">
                      <div className="card-header">Entry Notification</div>
                      <div className="card-body">

                        <UiToggle
                          id="entry_copy"
                          name="entry_copy"
                          value="1"
                          title="Enable Entry Notification"
                          {...register("entry_copy")}
                        />
                        <UiInput
                          name={`entry_copy_to`}
                          required={true}
                          label="Mobile Number"
                          {...register(`entry_copy_to`)}
                          message={errors.entry_copy_to?.message}
                        />
                        
                      </div>
                    </div>

                  </div>
                </div>



                <UiButton className="btn btn-primary " type="submit" title="Save" />

              </form>

            </div>
            : <BgLoader />
          }
        </div>
      </div>
    </>
  );
}
